// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileSelectFile_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 0 2 4 6 4 6 0ZM9.65412 14 9.8483 16H2V5H4V14H9.65412ZM12 2 12 7.66779 14 9.46672 14 0H7V2H12ZM14.416 15.9989 13.6707 16.0003 12.0304 12.7361 11.0272 14.6141 10.7329 14.7619 9.99998 7.21289 15.6474 12.2925 15.3531 12.4404 13.2218 12.1374 14.862 15.4017 14.416 15.9989Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 0H16V1.99938L6 1.99938V27.9913L18.45 27.9913 18.65 29.9907 4 29.9907V0ZM24.8722 24.3992 28.2246 31.106 27.5536 32 26.4355 31.9997 23.083 25.2928 21.0793 28.5688 20.5455 28.3908 19.5076 15.9034 29.0016 24.3439 28.7223 24.7666 24.8722 24.3992ZM26 18.9998V9.9969H24V17.2217L26 18.9998ZM26 7.99752 18 0V7.99752H26Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileSelectFile is a generated icon component.
 */
let IconFilesFileSelectFile = IconFilesFileSelectFile_1 = class IconFilesFileSelectFile extends IconBaseElement {
    render() {
        return html `${IconFilesFileSelectFile_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileSelectFile.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconFilesFileSelectFile = IconFilesFileSelectFile_1 = __decorate([
    customElement('zui-icon-files-file-select-file')
], IconFilesFileSelectFile);
export { IconFilesFileSelectFile };
